document.addEventListener('DOMContentLoaded', () => {
    // Инициализация всех ползунков
    document.querySelectorAll('[data-slider-input]').forEach(range => {
        const container = range.closest('.tw\\:relative');
        if (!container) return;

        const display = container.querySelector('[data-slider-display]');
        const fill = container.querySelector('[data-slider-fill]');
        const min = parseInt(range.min) || 0;
        const max = parseInt(range.max) || 100;

        function update() {
            const value = parseInt(range.value) || 0;
            const percent = max > min ? Math.round((value - min) / (max - min) * 100) : 0;

            if (display) display.textContent = value;
            if (fill) fill.style.width = percent + '%';
        }

        update();

        range.addEventListener('input', update);
        range.addEventListener('change', update);
    });
});

/**
 * Переключение режима ползунка (активный/отключенный)
 * @param {HTMLElement|string} container - элемент или селектор
 * @param {boolean} disabled - true - только число, false - ползунок
 */
export function toggleSlider(container, disabled) {
    if (!container) return;

    const range = container.querySelector('[data-slider-input]');
    const fill = container.querySelector('[data-slider-fill]');
    const display = container.querySelector('[data-slider-display]');
    const track = fill?.parentElement;

    if (!range || !fill || !display || !track) return;

    if (disabled) {
        // Делаем неактивным
        range.disabled = true;

        // Убираем фон у трека
        track.classList.remove('tw:bg-gray-200');
        track.style.backgroundColor = 'transparent';

        // Убираем цвет у заполнения
        fill.classList.remove('tw:bg-blue-500');
        fill.style.backgroundColor = 'transparent';

        // Меняем отображение числа: выравниваем вправо, убираем жирность
        display.classList.remove('tw:text-gray-700', 'tw:font-semibold', 'tw:justify-center');
        display.classList.add('tw:justify-end');

    } else {
        // Делаем активным
        range.disabled = false;

        // Возвращаем фон треку
        track.classList.add('tw:bg-gray-200');
        track.style.backgroundColor = '';

        // Возвращаем цвет заполнению
        fill.classList.add('tw:bg-blue-500');
        fill.style.backgroundColor = '';

        // Возвращаем отображение числа: по центру, жирный, темный
        display.classList.remove('tw:justify-end');
        display.classList.add('tw:text-gray-700', 'tw:font-semibold', 'tw:justify-center');
    }
}
